import $ from 'jquery';

$(() => {
  const $hamburger = $('.js-hamburger');
  const $mobileNav = $('body');

  $hamburger.on('click', () => {
    $hamburger.toggleClass('is-active');
    $mobileNav.toggleClass('mobile-nav-active');

    $('html, body').animate({ scrollTop: 0 }, 600);
  });
});



// WEBPACK FOOTER //
// ./_components/hamburger/index.js